/** @import {MaturityInstructionOtpModalProps} from './MaturityInstructionOtpModalTypes' */
/** @import {CustomVerification} from "../MyProfile/OTPModalTypes" */

import {gql} from "apollo-boost";
import OTPModal from "../MyProfile/OTPModal";
import React from "react";
import {useMutation} from "@apollo/react-hooks";
import successCheckMark from "../../assets/images/success.png"
import Button from "../Form/Button/Button";
import "../SharedComponents/button-styles.scss"
import "./maturityInstructionForm.scss"
import "../Session/login.scss"
import {useLogger} from "../../contexts/Logger";
import withFeatureFlags from "../FeatureFlags/withFeatureFlags";
import {useUnifiedAnalytics} from "../../contexts/AnalyticsWrapper";
function MaturityInstructionOtpModal(/** @type {MaturityInstructionOtpModalProps} */ props) {

    const logger = useLogger();
    const analytics = useUnifiedAnalytics();

    const SAVE_MATURITY_INSTRUCTION_V2 = gql`
        mutation saveMaturityInstructionV2($request : SaveMaturityInstructionRequestTypeV2!){
            saveMaturityInstructionV2(request:$request) {
                success,
                message
            }
        }
    `;

    const [saveInstructionV2] = useMutation(SAVE_MATURITY_INSTRUCTION_V2);

    /** @type {CustomVerification} */
    const customVerification = async (otp, mode) => {
        let result;

        if (!otp || !mode || !props.verificationToken){
            logger.error(`Attempting to save maturity instruction with invalid otp data`, {
                additionalData:{
                    otpExists: !!otp,
                    verificationTokenExists: !!props.verificationToken,
                    mode: mode
                }
            })
        }

        logger.info(`Saving maturity instruction with verification started`, {
            additionalData: {
                accountId: props.account?.id || '',
                instruction: props.instruction ? props.instruction.name || props.instruction : '',
                destinationAccountId: props.destinationAccountId ? props.destinationAccountId : '',
                otpExists: !!otp,
                verificationTokenExists: !!props.verificationToken,
                mode: mode,
                rolloverAccountProductId: props.instruction && props.instruction.options && props.instruction.options.rolloverAccountProductId
                    ? props.instruction.options.rolloverAccountProductId
                    : ''
            }
        });
        
        try
        {
            const instructionRequest = {
                accountId: props.account?.id || '',
                instruction: props.instruction?.name || props.instruction,
                destinationAccountId: props.destinationAccountId ||
                    props.instruction?.options?.selectedTransferAccount?.id ||
                    '00000000-0000-0000-0000-000000000000',
                verifyOtp: {
                    passCode: otp,
                    verificationToken: props.verificationToken,
                    mode: mode
                },
                rolloverAccountProductId:props.instruction?.options &&
                props.instruction.options.rolloverAccountProductId
                    ? props.instruction.options.rolloverAccountProductId
                    : null,
                partialRolloverAmount: props.instruction?.options?.partialRolloverAmount || 0,
                remainingBalanceWithdrawalAmount: props.instruction?.options?.remainingBalanceWithdrawalAmount || 0
            };

            result = await saveInstructionV2({ variables: { request: instructionRequest }});

            const success = result.data.saveMaturityInstructionV2.success;
            const message = result.data.saveMaturityInstructionV2.message;

            logger.info(`Saving maturity instruction with verification ${success ? 'succeeded' : 'failed'}`, {
                additionalData: {
                    accountId: props.account?.id || '',
                    success: success ? success : '',
                    message: message ? message : ''
                }
            });

            if (!success) {
                return {
                    success: success,
                    data: {approved: false},
                    message: message
                }
            }

            analytics.trackAnalyticsPopupEvent(
                "we've confirmed your instruction",
                'otp',
                "Instruction Confirmation",
                "instruction|popup|otp",
                'maturity_confirm your instruction'
            );
        } catch (e) {
            return {
                success: false,
                data: {approved: false},
            }
        }
        return {
            success: result.data.saveMaturityInstructionV2.success,
            data: {approved: true}
        }
    }

    const onModalCancel = () => {
        props.onClose()
    };

    const onModalComplete = () => {
        analytics.trackAnalyticsClickEvent(
            "give my other instructions later",
            `/maturity-instruction`,
            "confirm payaway modal",
            "fixed rate saver",
            "maturity",
            {},
            "link click",
            "instruction|click|maturity",
            "maturity"
        );

        props.onOTPSuccess()
    };

    const giveInstructionOnAnotherAccount = () => {
        analytics.trackAnalyticsClickEvent(
            "give instruction for another account",
            `/maturity-instruction`,
            "confirm payaway modal",
            "fixed rate saver",
            "maturity",
            {},
            "link click",
            "instruction|click|maturity",
            "maturity"
        );

        window.location.href = "/maturity-instruction"
    }

    const modalContent = () => {
        return <div className={"container"}>
            <img src={successCheckMark} className={"image__centered"} style={{paddingTop: "0"}}/>
            <h1 className="text__title">We’ve received your instruction</h1>
            {props.multipleMaturingAccounts ?
                <div className={"maturity3__flex-row maturity3__flex-row--left-align maturity3__no-wrap"}>
                    <Button size='med' customClassNames={["modal__button", "navigation-button--flex", "navigation-button"]} label="Give instruction for another account" onClick={() => giveInstructionOnAnotherAccount()}/>
                    <Button size='med' customClassNames={["modal__button", "navigation-button--flex", "navigation-button__back", "navigation-button--right"]} label="Give my other instructions later" onClick={onModalComplete}/>
                </div> :
                <Button size='med' customClassNames={["modal__button", "login__button", "login__button--margin-top"]} label="Done" onClick={onModalComplete}/>
            }
        </div>
    }

    if (props.showModal) {
        return <div>
            <OTPModal
                title="Confirm your instruction"
                mobileNumber={props.mobileNumber || ''}
                customLayout={modalContent()}
                onClose={onModalCancel}
                onComplete={onModalComplete}
                verificationToken={props.verificationToken}
                customVerification={customVerification}
                customClassName={"maturity3__confirmation-modal"}
                showConfirmationOnSuccess={props.showConfirmationOnSuccess}
            />
        </div>
    }
    return null;
}

export default withFeatureFlags(MaturityInstructionOtpModal)